import script from "./IndexFeather.vue?vue&type=script&lang=ts&setup=true"
export * from "./IndexFeather.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__